export const environment = {
  production: true,
  apiUrl: 'https://api.aulavirtualicaroaph.com.co/v1/'
  //apiUrl: 'https://aprendedigital.caffi.com.co/api/v1/'
  //apiUrl: 'https://cevcagroup.com/api/v1/'
};
